/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchUiPreferenceUserSettingDataParser = 
/* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['value', codec.unknown],
]);
export class PatchUiPreferenceUserSettingData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchUiPreferenceUserSettingDataParser.decode(input).map(res => new PatchUiPreferenceUserSettingData(res));
    }
    static unsafeDecode(input) {
        return PatchUiPreferenceUserSettingData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchUiPreferenceUserSettingDataParser.encode(data);
    }
    static schema() {
        return PatchUiPreferenceUserSettingDataParser.schema();
    }
}
